/**
 * Shown when the session can no longer be renewed without the user.
 *
 * Non-blocking on purpose: the page underneath stays as it was, so signing back in
 * picks up exactly where they left off. The sign-in only starts from the button —
 * a popup opened by a background request is blocked by browsers, and an unasked-for
 * one is what made a lost token feel like being thrown out.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './SessionExpiredPrompt.css';

function SessionExpiredPrompt({ onSignIn }) {
    const [busy, setBusy] = useState(false);
    const [failed, setFailed] = useState(false);

    const handleClick = async () => {
        setBusy(true);
        setFailed(false);
        const ok = await onSignIn();
        // On success this component unmounts; only a failed attempt lands here.
        if (ok === false) {
            setFailed(true);
            setBusy(false);
        }
    };

    return (
        <div className="session-expired" role="alert">
            <span className="session-expired-dot" aria-hidden="true" />
            <span className="session-expired-text">
                {failed
                    ? 'Sign-in didn’t go through. Please try again.'
                    : 'Your session expired — sign in again to keep working.'}
            </span>
            <button type="button" className="session-expired-btn" onClick={handleClick} disabled={busy}>
                {busy ? 'Signing in…' : 'Sign in again'}
            </button>
        </div>
    );
}

SessionExpiredPrompt.propTypes = {
    onSignIn: PropTypes.func.isRequired,
};

export default SessionExpiredPrompt;
